import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Link } from "react-router-dom";
import { ScrollText, ArrowRight } from "lucide-react";

export default function VentesRealisees() {
  return (
    <>
      <SEO
        title="Ventes réalisées — venteaterme.fr"
        description="Les premières opérations de vente à terme accompagnées via venteaterme.fr seront présentées ici prochainement, en toute transparence."
      />
      <section className="pt-24 pb-10 bg-navy text-cream">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">Références</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-tight text-balance">Ventes réalisées</h1>
          <p className="text-cream/80 mt-6 max-w-3xl">Un aperçu, à venir, des opérations conclues via notre plateforme — données anonymisées, arrondies, transactions signées chez notaire.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <Breadcrumbs items={[{ href: "/", label: "Accueil" }, { href: "/ventes-realisees", label: "Ventes réalisées" }]} />

          <div data-testid="empty-state-ventes" className="bg-white border border-navy/10 p-10 md:p-14 text-center">
            <div className="mx-auto w-14 h-14 border border-accent-brand/40 bg-accent-brand/5 flex items-center justify-center mb-6">
              <ScrollText size={26} className="text-accent-brand" strokeWidth={1.4} />
            </div>
            <h2 className="font-serif text-2xl md:text-3xl text-navy mb-3 text-balance">Les premières opérations accompagnées seront affichées ici prochainement.</h2>
            <p className="text-navy/70 max-w-xl mx-auto leading-relaxed mb-8">
              Par transparence, nous ne publions que des opérations réellement finalisées chez notaire. La liste sera enrichie dès la clôture des premières transactions accompagnées via&nbsp;venteaterme.fr.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <Link to="/annonces" data-testid="empty-state-ventes-annonces"
                className="inline-flex items-center justify-center gap-2 bg-accent-brand text-white px-6 py-3 text-sm font-bold tracking-wide hover:bg-[#B08D22] transition-colors">
                Voir les annonces disponibles <ArrowRight size={16} />
              </Link>
              <Link to="/simulateur" data-testid="empty-state-ventes-simuler"
                className="inline-flex items-center justify-center gap-2 border border-navy text-navy px-6 py-3 text-sm font-bold tracking-wide hover:bg-navy hover:text-cream transition-colors">
                Simuler mon opération
              </Link>
            </div>
          </div>

          <p className="text-xs text-navy/50 italic pt-6 text-center">Toutes les transactions sont conclues chez notaire, avec inscription de l’hypothèque légale spéciale et clause résolutoire.</p>
        </div>
      </section>
    </>
  );
}
